import React from 'react';
import { toast } from 'react-toastify';
import SVG from 'react-inlinesvg';
import { checkCircleSVG } from '../../shared/helpers/icons';
import styles from '../../shared/styles/notifications.module.scss';
import { takeLatest, put, call, select, debounce, delay } from "redux-saga/effects";
import {
    GET_SIM_CARDS_REQUEST,
    getSimCardsRequest,
    getSimCardsSuccess,
    getSimCardsFailure,
    SUBMIT_SIM_CARDS_BATCH_REQUEST,
    submitSimCardsBatchSuccess,
    submitSimCardsBatchFailure,
    setStateSimcards,
    GET_SIM_CARDS_STATUSES_REQUEST,
    getSimcardsStatusesSuccess,
    getSimcardsStatusesFailure,
    SUBMIT_SIM_CARDS_REQUEST,
    submitSimcardsSuccess,
    submitSimcardsFailure,
    GET_TYPING_SIM_CARDS_REQUEST,
    SUBMIT_SIM_CARDS_STATUSES_REQUEST,
    submitSimcardsStatusesSuccess,
    submitSimcardsStatusesFailure,
    SUBMIT_SIMCARDS_VALIDATE_BATCH_REQUEST,
    submitSimcardsValidateBatchSuccess,
    submitSimcardsValidateBatchFailure,
    GET_EXPORT_SIMCARDS_REQUEST,
    getExportSimcardsFailure,
    getExportSimcardsSuccess,
    CLOSE_PING_EVENT_EXPORT_SIMCARDS,
    GET_SIM_CARDS_SUBSTATUSES_REQUEST,
    getSimcardsSubstatusesSuccess,
    getSimcardsSubstatusesFailure,
    GET_HISTORY_SIM_CARDS_REQUEST,
    getHistorySimcardsSuccess,
    getHistorySimcardsFailure,
    PATCH_SIMCARDS_BATCH_REQUEST,
    patchSimcardsBatchSuccess,
    patchSimcardsBatchFailure
} from "../actions/simcards";

import {
    getSimCards,
    postBatchSimCard,
    patchSimcards,
    getSimcardsStatuses,
    getSimcardsSubstatuses,
    putSimcard,
    postSimcardsStatuses,
    putSimcardsStatuses,
    postValidateBatchSimcards,
    getExportSimcardsService,
    getHistorySimcards
} from "../services/simcard";
import { pingEvent, pingEventBeforeSubmitBatch } from "../../shared/sagas/events";
import { showGlobalError } from "../../app/actions/app";
import { accessTokenSelector } from "../../auth/selectors/token";

const getSimcardsWorker = function* ({ payload: { filters } }) {
    try {
        const token = yield select(accessTokenSelector);

        const {
            data: { simcards, total }
        } = yield call(getSimCards, filters, token);
        
        const isFirstPage = !filters.page || filters.page === 1;
        
        yield put(getSimCardsSuccess(simcards, total, isFirstPage));
    } catch (err) {
        yield put(getSimCardsFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const getSimcardStatusesWorker = function* ({ payload: { filters } }) {
    try {
        const token = yield select(accessTokenSelector);
        const {
            data: { statuses, total }
        } = yield call(getSimcardsStatuses, filters, token);

        yield put(getSimcardsStatusesSuccess(statuses, total));
    } catch (err) {
        yield put(getSimcardsStatusesFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const getSimcardSubstatusesWorker = function* ({ payload: { filters } }) {
    try {
        const token = yield select(accessTokenSelector);
        const response = yield call(getSimcardsSubstatuses, filters, token);
        const { data } = response;
        const substatuses = data.substatus || [];
        const total = data.total || 0;
        
        yield put(getSimcardsSubstatusesSuccess(substatuses, total));
    } catch (err) {
        yield put(getSimcardsSubstatusesFailure(err));
        yield put(showGlobalError(true, err));
    }
};



const getHistorySimcardsWorker = function* ({ payload }) {
    try {
        const token = yield select(accessTokenSelector)
        const iccid = payload;

        const {
            data: { history, total }
        } = yield call(getHistorySimcards, iccid, token);

        yield put(getHistorySimcardsSuccess(history, total));
    } catch (err) {
        yield put(getHistorySimcardsFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const submitSimcardsBatchWorker = function* ({ payload: { simCard, options = {} } }) {
    try {
        const token = yield select(accessTokenSelector);

        const {
            data: { event }
        } = yield call(postBatchSimCard, simCard, token);
        
        // Esperar a que el evento termine y marcar como listo para PATCH
        if (event && event._id) {
            try {
                yield call(pingEventBeforeSubmitBatch, event._id, token);
                // Una vez que pingEventBeforeSubmitBatch termina con éxito, la carga está lista
                yield put(setStateSimcards({ isReadyForPatch: true }));
            } catch (pingError) {
                console.error('Error en pingEventBeforeSubmitBatch:', pingError);
                yield put(setStateSimcards({ isReadyForPatch: false }));
            }
        }

        yield put(submitSimCardsBatchSuccess());
        toast.success(
            <div className={styles.customToastSuccess}>
                <div className={styles.toastContent}>
                    <SVG src={checkCircleSVG} className={styles.toastIconSuccess} />
                   Simcards cargadas con éxito
                </div>
            </div>,
            {
                className: styles.toast,
                toastId: `simcards-created-${Date.now()}`
            }
        );
        
        if (!options.skipReset) {
            yield put(setStateSimcards({ submitSuccess: false }));
        }
    } catch (err) {
        yield put(submitSimCardsBatchFailure());
        yield put(showGlobalError(true, err, err.key));
        yield put(setStateSimcards({ isReadyForPatch: false }));
    }
};

const submitSimcardsWorker = function* ({ payload: { simCard } }) {
    try {
        const token = yield select(accessTokenSelector);

        yield call(putSimcard, simCard, token);

        yield put(submitSimcardsSuccess());
        toast.success(
            <div className={styles.customToastSuccess}>
                <div className={styles.toastContent}>
                    <SVG src={checkCircleSVG} className={styles.toastIconSuccess} />
                   Simcards creadas con éxito
                </div>
            </div>,
            {
                className: styles.toast,
                toastId: `user-created-${Date.now()}`
            }
        );
        yield put(setStateSimcards({ submitSuccess: false }));
    } catch (err) {
        yield put(submitSimcardsFailure());
        yield put(showGlobalError(true, err, err.key));
    }
};

const submitSimcardsStatusWorker = function* ({ payload: { status } }) {
    try {
        const token = yield select(accessTokenSelector);

        if (!status._id) {
            yield call(postSimcardsStatuses, status, token);
            yield put(showGlobalError(true, 200, "created"));
        } else {
            yield call(putSimcardsStatuses, status, token);
            yield put(showGlobalError(true, 200, "updated"));
        }

        yield put(submitSimcardsStatusesSuccess());
    } catch (err) {
        yield put(submitSimcardsStatusesFailure());
        yield put(showGlobalError(true, err));
    }
};

const submitSimcardsValidateBatchWorker = function* ({ payload: { simcard } }) {
    try {

        const token = yield select(accessTokenSelector);

        const {
            data: { validations }
        } = yield call(postValidateBatchSimcards, simcard, token);

        yield put(submitSimcardsValidateBatchSuccess(validations));
        yield put(setStateSimcards({ submitValidateBatchSuccess: false }));

    } catch (err) {
        yield put(submitSimcardsValidateBatchFailure());
        yield put(showGlobalError(true, err, err.key));
    }
};

const getExportSimcardsWorker = function* ({ payload: { filters }}) {
    try {
        const accessToken = yield select(accessTokenSelector);

        const response = yield call(getExportSimcardsService, filters, accessToken);

        // El API retorna directamente el archivo Excel, no un evento
        if (response.data && response.status === 200) {
            
            // Crear blob y descargar archivo
            const blob = new Blob([response.data], { 
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `simcards_export_${new Date().toISOString().slice(0,10)}.xlsx`);
            document.body.appendChild(link);
            link.click();
            
            // Limpiar
            setTimeout(() => {
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }, 100);
            
            yield put(getExportSimcardsSuccess({ success: true }));
        } else {
            yield put(getExportSimcardsFailure());
        }
    } catch (err) {
        yield put(getExportSimcardsFailure());
        yield put(showGlobalError(true, err));
    }
}

const patchSimcardsBatchWorker = function* ({ payload: { simcards, options = {} } }) {
    try {
      const token = yield select(accessTokenSelector);
      
      yield call(patchSimcards, simcards, token); 
      
      yield put(patchSimcardsBatchSuccess());
      
    toast.success(
        <div className={styles.customToastSuccess}>
            <div className={styles.toastContent}>
                <SVG src={checkCircleSVG} className={styles.toastIconSuccess} />
               Simcards modificadas con éxito
            </div>
        </div>,
        {
            className: styles.toast,
            toastId: `simcards-updated-${Date.now()}`
        }
      );
      
      yield put(setStateSimcards({ submitSuccess: false }));
      
      yield delay(500);

      const isUnsubscribeOperation = simcards?.data?.status === 'baja';
      
      if (!isUnsubscribeOperation) {
        try {
          if (options && options.skipListReload) {
            return;
          }

          const specificFilters = {
            full_assigned: 1,
            limit: 50,
            page: 1
          };
          
          yield put(getSimCardsRequest(specificFilters));
          
        } catch (getError) {
          console.error('Error al obtener simcards actualizadas:', getError);
        }
      } else {
      }
      
    } catch (err) {
      yield put(patchSimcardsBatchFailure());
      yield put(showGlobalError(true, err, err.key));
    }
  };

export default [
    takeLatest(GET_SIM_CARDS_REQUEST, getSimcardsWorker),
    debounce(500, GET_TYPING_SIM_CARDS_REQUEST, getSimcardsWorker),
    takeLatest(GET_SIM_CARDS_STATUSES_REQUEST, getSimcardStatusesWorker),
    takeLatest(GET_SIM_CARDS_SUBSTATUSES_REQUEST, getSimcardSubstatusesWorker),
    takeLatest(SUBMIT_SIM_CARDS_BATCH_REQUEST, submitSimcardsBatchWorker),
    takeLatest(SUBMIT_SIM_CARDS_REQUEST, submitSimcardsWorker),
    takeLatest(SUBMIT_SIM_CARDS_STATUSES_REQUEST, submitSimcardsStatusWorker),
    takeLatest(SUBMIT_SIMCARDS_VALIDATE_BATCH_REQUEST, submitSimcardsValidateBatchWorker),
    takeLatest(GET_EXPORT_SIMCARDS_REQUEST, getExportSimcardsWorker),
    takeLatest(GET_HISTORY_SIM_CARDS_REQUEST, getHistorySimcardsWorker),
    takeLatest(PATCH_SIMCARDS_BATCH_REQUEST, patchSimcardsBatchWorker)
];
